import { fetchJson } from '@gjensidige/gpf-js-utils/es6/fetch/fetchJson';
import { fieldwiseTransform } from '@gjensidige/gpf-js-utils/es6/fetch/transform';
import { LocalDate } from '@gjensidige/gpf-js-utils/es6/time/LocalDate';
const API = `/gpf-fkl/api`;
export const LOGGER_ENDPOINT = `${API}/remote-logger`;
export const FEATURE_FLAG_ENDPOINT = `${API}/feature-flags`;
export function validateCustomer(ssn, firstName, surname) {
    return fetchJson(`${API}/validate/customer`, 'POST', {
        ssn: ssn,
        firstName: firstName,
        surname: surname,
    });
}
export function submitFormData(formDataPayload) {
    return fetchJson(`${API}/sign`, 'POST', formDataPayload);
}
export function getSubmittedFormData(requestId) {
    return fetchJson(`${API}/sign/${requestId}`);
}
export function getSignResult(requestId) {
    return fetchJson(`${API}/sign/result/${requestId}/status`);
}
export function getAvtaleGiroUrl(signingId) {
    return fetchJson(`${API}/avtalegiro/${signingId}/url`);
}
export function getLoggedInCustomerData() {
    return fetchJson(`${API}/customer/data`);
}
function paymentInfoTransform() {
    return fieldwiseTransform({
        expectedTrekkdato: LocalDate.parse,
    });
}
export function getPaymentInfo(kid) {
    return fetchJson(`${API}/avtalegiro/${kid}/betalingsinfo`, 'GET', undefined, paymentInfoTransform());
}
export const putChosenProfile = (ref, profil) => fetchJson(`${API}/profil/${ref}`, 'POST', { profil });
export const getAnbefaltProfilOgPortefølje = (raadgivningRef, uttaksalder) => fetchJson(`${API}/profil/anbefaling/${raadgivningRef}?uttaksalder=${uttaksalder}`);
export const getPorteføljeForAlleRisikoprofiler = (uttaksalder) => fetchJson(`${API}/profil/alle-portefoljer?uttaksalder=${uttaksalder}`);
export const getUtbetalingsdetaljer = (spareformål) => fetchJson(`${API}/customer/utbetalingsdetaljer?spareformål=${spareformål}`);
export function validateUttaksalder(validationRequest) {
    return fetchJson(`${API}/validate/uttaksalder`, 'POST', validationRequest);
}
export const raadgivningController = {
    startAndGetRaadgivning: (raadgivningType) => fetchJson(`${API}/raadgivning?raadgivningType=${raadgivningType}`),
    saveEgnethetstest: (ref, raadgivning) => fetchJson(`${API}/raadgivning/${ref}/egnethetstest`, 'POST', raadgivning),
};
